<template>
  <!---全体を囲む--->
  <div>
    <!-- メイン画面 -->
    <div v-if="isReadyToDraw" class="content-wrapper">
      <!-- 施設情報表示 -->
      <TheFacilityCard
        v-if="recommendations.id"
        :background-img-u-r-l="recommendations.image_url"
        :list-item1="recommendations.master_books[0].name"
        :list-item2="recommendations.comment"
        :list-item3="recommendations.name"
        :button1-action="gotoPlaceRecommendation"
        :button2-action="goToDetailRecommendation"
      />
      <!-- 施設情報表示 -->

      <!-- index画面の描画ローディング -->
      <ItemDialogForIndexPage v-else />
    </div>
    <!-- メイン画面 -->

    <!-- isReadyToDrawがtrueになるまで -->
    <FacePhraseForIndexPage v-else phrase="近隣スポットがありません" />
  </div>
  <!---全体を囲む--->
</template>
<script>
import { mapGetters } from "vuex";
// ネイティブから送られてくる情報をストアへ格納
window.jcSetRecommendInfo = function (info) {
  storeJS.commit("recommendations/setRecommendations", info);
};
export default {
  async mounted() {
    if (this.$store.getters["common/device"] == "BROWSER") {
      try {
        const info = await this.$store.dispatch(
          "recommendations/getRecommendations",
          {
            // geo: '35.23,139.05'
            //geo: "35.6925233, 139.5141402" // 味の素スタジアム
            geo: "35.690921,139.70025799999996", // Emotパス
            //geo: '35.6245965,139.4293108'   // サンリオ
            // geo: ' 35.6030393,139.5093083'   // 新百合ヶ丘
            // geo: "35.23364044,139.0958887" // 箱根湯寮
            // geo: "35.7,139.7" // バス無料チケット
            // geo: "34.732501, 137.688938" // 浜松
          }
        );
        await window.jcSetRecommendInfo(info);
      } catch (err) {
        await window.jcSetRecommendInfo("");
      }
    } else {
      // 周辺・カーシェア・レンタカーでページ描画完了をマップWebviewへ知らせる関数
      this.ncPageReady();
    }
  },
  methods: {
    gotoPlaceRecommendation() {
      this.ncGotoPlaceRecommendation(this.recommendations);
    },
    async goToDetailRecommendation() {
      await this.ncSetPlaceInfoRecommendation(this.recommendations);
      await this.$router.push({
        name: "RecommendationDetail",
        params: {
          index: 0,
        },
        query: { language: this.$store.getters["common/lang"] },
      });
    },
  },
  computed: {
    isReadyToDraw() {
      return this.recommendations;
    },
    ...mapGetters("ticketing", ["masterBooks"]),
    ...mapGetters("recommendations", ["recommendations"]),
  },
};
</script>
